import script from "./guide_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./guide_modal.vue?vue&type=script&setup=true&lang=js"

import "./guide_modal.vue?vue&type=style&index=0&id=3cff6880&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cff6880"]])

export default __exports__